import { fetchWithHeaders } from "./apimanager.helper";

/**
 *
 * @param { string } url
 * @returns {Promise<Blob>} blob of the file in the url
 */
export async function fetchBlob(url) {
  try {
    const response = await fetchWithHeaders(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file URL: ${response.statusText}`);
    }

    const blob = await response.blob();
    return blob;
  } catch (e) {
    console.error("Error fetching file URL:", e); //eslint-disable-line
  }
}

export async function downloadFile(url) {
  try {
    const blob = await fetchBlob(url);
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = downloadUrl;
    link.download = decodeURIComponent(new URL(url).pathname.split("/").pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(downloadUrl);
    return true;
  } catch (e) {
    console.error("Error downloading file:", e); //eslint-disable-line
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/fileDownloader.js